<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Major Characters in the Novel</span></p>
<p class="P_WFP_DramatisPersonae"><i>Harley M. Hudson</i>, President of the United States</p>
<p class="P_WFP_DramatisPersonae"><i>Lucille</i>, his wife</p>
<p class="P_WFP_DramatisPersonae"><i>Orrin Knox</i>, Secretary of State</p>
<p class="P_WFP_DramatisPersonae"><i>Beth</i>, his wife</p>
<p class="P_WFP_DramatisPersonae">Governor <i>Edward M. Jason</i> of California</p>
<p class="P_WFP_DramatisPersonae"><i>Ceil</i>, his wife</p>
<p class="P_WFP_DramatisPersonae"><i>Patsy Jason Labaiya</i>, his sister</p>
<p class="P_WFP_DramatisPersonae"><i>Selena Jason Castleberry</i>, their aunt</p>
<p class="P_WFP_DramatisPersonae"><i>Valuela Jason Randall</i>, their aunt</p>
<p class="P_WFP_DramatisPersonae"><i>Herbert Jason</i>, their uncle</p>
<p class="P_WFP_DramatisPersonae">Senator <i>Robert Durham Munson</i> of Michigan, Majority Leader of the United States Senate</p>
<p class="P_WFP_DramatisPersonae"><i>Dolly</i>, his wife</p>
<p class="P_WFP_DramatisPersonae">Senator <i>Stanley Danta</i> of Connecticut, Majority Whip of the Senate</p>
<p class="P_WFP_DramatisPersonae">The Speaker of the House</p>
<p class="P_WFP_DramatisPersonae">Representative <i>Cullee Hamilton</i> of California</p>
<p class="P_WFP_DramatisPersonae">Senator <i>Lafe Smith</i> of Iowa</p>
<p class="P_WFP_DramatisPersonae">Representative <i>J. B. “Jawbone” Swarthman</i> of South Carolina, chairman of the House Foreign Affairs Committee</p>
<p class="P_WFP_DramatisPersonae">Senator <i>Tom August</i> of Minnesota, chairman of the Senate Foreign Relations Committee</p>
<p class="P_WFP_DramatisPersonae"><i>Robert A. Leffingwell</i>, Director of the President’s Commission on Administrative Reform</p>
<p class="P_WFP_DramatisPersonae"><i>Walter Dobius</i>, a columnist</p>
<p class="P_WFP_DramatisPersonae"><i>Helen-Anne Carrew</i>, another columnist</p>
<p class="P_WFP_DramatisPersonae">The executive chairman of The Greatest Publication That Absolutely Ever Was</p>
<p class="P_WFP_DramatisPersonae">Members of Walter’s world</p>
<p class="P_WFP_DramatisPersonae">The working press</p>
<p class="P_WFP_BodyTextFirstPara"> </p>
<p class="P_WFP_BodyTextFirstPara">AT THE UN</p>
<p class="P_WFP_DramatisPersonae">His Royal Highness <i>Terence Wolowo Ajkaje</i>, 137th M’Bulu of Mbuele; “Terrible Terry”</p>
<p class="P_WFP_DramatisPersonae">His Royal Highness <i>Obifumatta Ajkaje</i>, his cousin; “Prince Obi”</p>
<p class="P_WFP_DramatisPersonae"><i>Vasiliy Tashikov</i>, Ambassador of the U.S.S.R.</p>
<p class="P_WFP_DramatisPersonae"><i>Krishna Khaleel</i>, Ambassador of India</p>
<p class="P_WFP_DramatisPersonae">Lord <i>Claude Maudulayne</i>, Ambassador of the United Kingdom</p>
<p class="P_WFP_DramatisPersonae"><i>Kitty</i>, his wife</p>
<p class="P_WFP_DramatisPersonae"><i>Raoul Barre</i>, Ambassador of France</p>
<p class="P_WFP_DramatisPersonae"><i>Celestine</i>, his wife</p>
<p class="P_WFP_DramatisPersonae">The Secretary-General</p>
<p class="P_WFP_DramatisPersonae">Members of Walter’s world</p>
<p class="P_WFP_DramatisPersonae">The working press</p>
<p class="P_WFP_BodyTextFirstPara"> </p>
<p class="P_WFP_BodyTextFirstPara">AT THE CONVENTION</p>
<p class="P_WFP_DramatisPersonae"><i>Hal Knox</i>, son of the Secretary of State</p>
<p class="P_WFP_DramatisPersonae"><i>Crystal Danta Knox</i>, his wife</p>
<p class="P_WFP_DramatisPersonae">Mrs. <i>Mabel Anderson</i>, widow of the late Senator Brigham Anderson of Utah</p>
<p class="P_WFP_DramatisPersonae"><i>Roger P. Croy</i>, National Committeeman from Oregon</p>
<p class="P_WFP_DramatisPersonae">Mrs. <i>Esmé Harbellow Stryke</i>, National Committeewoman from California</p>
<p class="P_WFP_DramatisPersonae">Mrs. <i>Mary Buttner Baffleburg</i>, National Committeewoman from Pennsylvania</p>
<p class="P_WFP_DramatisPersonae">Miss <i>Lizzie Hanson McWharter</i>, National Committeewoman from Kansas</p>
<p class="P_WFP_DramatisPersonae">Mrs. <i>Anna Hooper Bigelow</i>, National Committeewoman from New Hampshire</p>
<p class="P_WFP_DramatisPersonae"><i>Joe Smitters</i>, <i>Bill Smatters</i>, <i>Bob Smutters</i>, <i>John Smotters</i>, <i>Buddy Smetters</i>: county chairmen</p>
<p class="P_WFP_DramatisPersonae">Senator <i>Fred Van Ackerman</i> of Wyoming, spokesman for the Committee on Making Further Offers for a Russian Truce (COMFORT)</p>
<p class="P_WFP_DramatisPersonae"><i>LeGage Shelby</i>, national chairman of Defenders of Equality for You (DEFY)</p>
<p class="P_WFP_DramatisPersonae"><i>Rufus Kleinfert</i>, Knight Kommander of the Konference on Efforts to Encourage Patriotism (KEEP)</p>
<p class="P_WFP_DramatisPersonae"><i>Booker T. Saunders</i>, a hero</p>
<p class="P_WFP_DramatisPersonae"><i>William Everett Hollister II</i>, another hero</p>
<p class="P_WFP_DramatisPersonae"><i>Frankly Unctuous</i>, an Anchor Man</p>
<p class="P_WFP_DramatisPersonae">Members of Walter’s world</p>
<p class="P_WFP_DramatisPersonae">The working press</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0006.vue?a28f3bfc